import { render, staticRenderFns } from "./addClassSubject.vue?vue&type=template&id=0ac8f63e"
import script from "./addClassSubject.vue?vue&type=script&lang=js"
export * from "./addClassSubject.vue?vue&type=script&lang=js"
import style1 from "./addClassSubject.vue?vue&type=style&index=1&id=0ac8f63e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports